import script from "./pdf_comment_form.vue?vue&type=script&setup=true&lang=js"
export * from "./pdf_comment_form.vue?vue&type=script&setup=true&lang=js"

import "./pdf_comment_form.vue?vue&type=style&index=0&id=9813d28a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9813d28a"]])

export default __exports__